'use client';
import React from 'react';
import ProfileBanner, { ProfileBannerProps } from './_ProfileBanner';
import DeliveryIdContext from '../../context/delivery-id-context';

interface AuthorClientProps extends ProfileBannerProps {
  _meta?: { deliveryId?: string };
  children?: React.ReactNode;
}

const AuthorClientBoundary = ({ _meta, children, ...props }: AuthorClientProps) => {
  return (
    <>
      <div className="rotating-background">
        <ProfileBanner {...props} />
      </div>
      <DeliveryIdContext.Provider value={_meta?.deliveryId}>
        {children}
      </DeliveryIdContext.Provider>
    </>
  );
};

export default AuthorClientBoundary;
